import TechSectionHeader from "./TechSectionHeader";
import TechStackGrid from "./TechStackGrid";
import { frontendTech } from "./technologies.data";

export default function TechFrontend() {
  return (
    <section className="tech-section">
      <TechSectionHeader
        title="Frontend"
        highlight="Technologies"
        subtitle="Fast, responsive, and conversion-focused interfaces."
      />
      <TechStackGrid items={frontendTech} />
    </section>
  );
}
